import { write, utils } from "xlsx";
import { saveAs } from "file-saver";
import { formatDateTime } from "./datetime";

export const exportToExcel = ({ data }) => {
  const worksheet = utils.json_to_sheet(data);
  const workbook = utils.book_new();
  utils.book_append_sheet(workbook, worksheet, "Sheet1");
  const excelBuffer = write(workbook, {
    bookType: "xlsx",
    type: "array",
  });
  const [date, time] = formatDateTime(new Date().toISOString());
  const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(blob, `Teacher_Report_${date}_${time}.xlsx`);
};
